import { useSettings } from "../context/SettingsContext";

export default function Marquee() {
  const { settings } = useSettings();
  if (!settings.marquee_enabled || !settings.marquee_text) return null;

  return (
    <div
      data-testid="marquee-bar"
      className="w-full overflow-hidden py-2 text-sm font-medium"
      style={{ backgroundColor: settings.marquee_bg || "#2B5B3A", color: settings.marquee_text_color || "#FFFFFF" }}
    >
      <div className="marquee-track whitespace-nowrap">
        <span className="mx-8">{settings.marquee_text}</span>
        <span className="mx-8">{settings.marquee_text}</span>
        <span className="mx-8">{settings.marquee_text}</span>
        <span className="mx-8">{settings.marquee_text}</span>
      </div>
    </div>
  );
}
